import environment from '~/stores/providers/environment';

const isMnd = environment.serviceTitle === '국방이음';
export const DEFAULT_TIMEOUT = isMnd ? 1000 * 30 : 1000 * 15; // 30 or 15 seconds
export const LOG_SEND_TIMEOUT = isMnd ? 1000 * 10 : 1000 * 5; // 10 or 5 seconds
export const FILE_SEND_TIMEOUT = 0; // infinite
